import axios from 'axios'
import { useEffect, useState } from 'react'

export default function useMaintenanceMessageService() {
    const messageUrl = 'http://musecore2.net/maintenance-message'

    const [maintenaceMessage, set_maintenaceMessage] = useState<string | null>(null)

    useEffect(() => {
        axios
            .get(messageUrl)
            .then((response) => {
                if (response.data) {
                    set_maintenaceMessage(response.data)
                }
            })
            .catch((e) => {
                console.error(
                    `useMaintenanceMessageService: failed to get maintenance message from ` + `"${messageUrl}". e=%O`,
                    e
                )
            })
    }, [])

    return {
        maintenaceMessage,
    }
}
